import SearchFlights from "../features/searchFlights/SearchFlights";
import MapboxMapWrapper from "../mapbox/MapboxMapWrapper";
import React from "react";
import HeaderLogo from "./HeaderLogo";
import OAGPromoLogo from "./OAGPromoLogo";
import OAGCopyright from "./OAGCopyright";

function MOT12() {
  return (
    <div className="container">
      <div id="mapbox-wrapper">
        <MapboxMapWrapper />
      </div>
      <HeaderLogo />
      <div id="search-results-column" className="mt-2">
        <SearchFlights layout="vertical" />
        <OAGCopyright />
        <OAGPromoLogo />
      </div>
    </div>
  );
}

export default MOT12;
